@import '~style-sheet-helpers/core';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/screen-width-breakpoints.module.less';
@import '../../../constants/spacing.module.less';

.shipment-read-only {
  font-size: 16px;
  width: 100%;
}

.read-only-fields {
  padding: 0 0 15px;
  display: flex;

  .fields {
    flex: 1;
    padding-top: 5px;

    .row {
      font-size: 14px;
      height: 16px;
      padding-left: 16px;
      margin-bottom: 12px;
    }

    .label {
      color: @read-only-shipment-display--label--text-color;
      width: 140px;
    }

    .info {
      display: flex;
      align-items: center;

      .link {
        font-size: 14px;
      }

      .icon {
        height: 14px;
        width: auto;
        margin-left: 5px;
      }
    }

    .marked-as-shipped {
      justify-content: space-between;
      padding-right: 25px;
    }

    .mdash {
      color: @read-only-shipment-display--mdash--text-color;
    }

    .rate {
      padding: 10px 10px 0;
      font-size: 18px;
      font-weight: 600;
      color: @read-only-shipment-display--rate--text-color;
    }

    .helper-text {
      font-size: 12px;
      line-height: 15px;
      height: 15px;
      padding-left: 16px;

      .link {
        font-size: 12px;
      }

      .icon {
        height: 12px;
        width: auto;
        margin-left: 5px;
      }
    }

    .rejected-banner {
      display: flex;
      margin: 6px 15px 16px;
    }
  }
}

.error-banner {
  align-items: center;
  padding: 5px 10px 5px 5px;
  border-radius: 5px;
  font-size: 14px;
  margin: 5px;
}

.insurance-label {
  padding-right: @space-8;
}

.claim-icon {
  height: 10px;
  margin-left: @space-4;
  color: var(--blue-600);
}
